export class FacadeInsertUnit {
  systemName: string;
  operationType: string | null;
  openingType: string | null;
  material: string | null;
  glassThicknessMin: number | null;
  glassThicknessMax: number | null;
  uf: number | null;

  constructor(
    row: Record<string, string | number | null>
  ) {
    this.systemName = row['systemName'] as string;
    this.operationType = row['operationType'] as string | null;
    this.openingType = row['openingType'] as string | null;
    this.material = row['material'] as string | null;
    this.glassThicknessMin = row['glassThicknessMin'] as number | null;
    this.glassThicknessMax = row['glassThicknessMax'] as number | null;
    this.uf = row['uf'] as number | null;
  }
}